export default __webpack_public_path__ + "static/media/skippedmeal_4@3x.a159a0cc.jpg";